import { EMAIL_VALIDATOR } from "helpers/validators";

const validateRecipient = (recipient) => {
  const errors = {};
  if (!recipient.name.trim()) errors.name = true;
  if (!recipient.email.trim()) errors.email = "empty";
  else if (!EMAIL_VALIDATOR.test(recipient.email)) errors.email = "invalid";
  return errors;
};

export default validateRecipient;
